<template>
  <li class="dropdown dropdown-extended dropdown-inbox"
      id="header_inbox_bar">
    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown"
       data-close-others="true">
      <i class="icon-bubble"></i>
      <span class="badge badge-warning">{{ user.hasOwnProperty('alerts') ? user.alerts.count : 0 }}</span>
    </a>
    <ul class="dropdown-menu">
      <li class="external">
        <h3>You have
          <span class="bold">{{ user.hasOwnProperty('alerts') ? user.alerts.count : 0 }}</span> new message{{ user.hasOwnProperty('alerts') && (user.alerts.count > 1 || user.alerts.count == 0) ? 's' : ''}}.
        </h3>
      </li>
      <li v-if="user.hasOwnProperty('alerts')">
        <ul class="dropdown-menu-list scroller" style="max-height: 308px; overflow: auto;" data-handle-color="#637283">
          <li v-for="alert in user.alerts.sms_alerts">
            <router-link :to="{ name: 'Messages', params: { id: alert.participantId } }" class="clearfix">
              <span class="photo">
                <avatar :username="alert.fullName" :src="alert.avatar" :size="40" :rounded="true" color="#d09f23" class="avatar" backgroundColor="#eef1f5"></avatar>
              </span>
              <span class="subject">
                <span class="from">{{ alert.fullName }}</span>
                <span class="time">{{ alert.createdAt.date | formatDateByArrival }}</span>
              </span>
              <span class="message"> You have <b>{{alert.count}}</b> new message{{ (alert.count > 1 || alert.count == 0) ? 's' : ''}}.</span>
            </router-link>
          </li>

          <li v-if="user.alerts.referral_alerts.count">
            <router-link :to="{ name: 'Referral Dashboard' }" class="clearfix">
              <span class="photo">
                <span class="avatar avatar-fa">
                  <i class="icon-users"></i>
                </span>
              </span>
              <span class="subject">
                <span class="from">{{ user.alerts.referral_alerts.title }}</span>
                <span class="time">{{ user.alerts.referral_alerts.createdAt.date | formatDateByArrival }}</span>
              </span>
              <span class="message"> You have <b>{{user.alerts.referral_alerts.count}}</b> new referral/application{{ (user.alerts.referral_alerts.count > 1) ? 's' : ''}}.</span>
            </router-link>
          </li>

          <li v-for="alert in user.alerts.assigned_case_manager">
            <router-link :to="{ name: 'Dashboard Participant', params: {id: alert.participantId}}" class="clearfix">
              <span class="photo">
                <avatar :username="alert.fullName" :src="alert.avatar" :size="40" :rounded="true" color="#d09f23" class="avatar" backgroundColor="#eef1f5"></avatar>
              </span>
              <span class="subject">
                <span class="from">{{ alert.title }}</span>
                <span class="time">{{ alert.createdAt.date | formatDateByArrival }}</span>
              </span>
              <span class="message">{{alert.body}}</span>
            </router-link>
          </li>

          <li v-for="alert in user.alerts.shared_form_completed">
            <router-link :to="{ name: 'Dashboard Participant', params: {id: alert.participantId}}" class="clearfix">
              <span class="photo">
                <avatar :username="alert.fullName" :src="alert.avatar" :size="40" :rounded="true" color="#d09f23" class="avatar" backgroundColor="#eef1f5"></avatar>
              </span>
              <span class="subject">
                <span class="from">{{ alert.title }}</span>
                <span class="time">{{ alert.createdAt.date | formatDateByArrival }}</span>
              </span>
              <span class="message">You have <b>{{alert.count}}</b> new submission{{ (alert.count > 1) ? 's' : ''}}.</span>
            </router-link>
          </li>

          <li v-for="alert in user.alerts.shared_form_failed">
            <router-link :to="{ name: 'Dashboard Participant', params: {id: alert.participantId}}" class="clearfix">
              <span class="photo">
                <avatar :username="alert.fullName" :src="alert.avatar" :size="40" :rounded="true" color="#d09f23" class="avatar" backgroundColor="#eef1f5"></avatar>
              </span>
              <span class="subject">
                <span class="from">{{ alert.title }}</span>
                <span class="time">{{ alert.createdAt.date | formatDateByArrival }}</span>
              </span>
              <span class="message">You have <b>{{alert.count}}</b> new exception{{ (alert.count > 1) ? 's' : ''}}.</span>
            </router-link>
          </li>

        </ul>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// Inbox.vue?51c66851